import { render, staticRenderFns } from "./FittingsRecord.vue?vue&type=template&id=690e35e4&scoped=true"
import script from "./FittingsRecord.vue?vue&type=script&lang=js"
export * from "./FittingsRecord.vue?vue&type=script&lang=js"
import style0 from "./FittingsRecord.vue?vue&type=style&index=0&id=690e35e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690e35e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('690e35e4')) {
      api.createRecord('690e35e4', component.options)
    } else {
      api.reload('690e35e4', component.options)
    }
    module.hot.accept("./FittingsRecord.vue?vue&type=template&id=690e35e4&scoped=true", function () {
      api.rerender('690e35e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Fittings/FittingsRecord/FittingsRecord.vue"
export default component.exports